import React from 'react';
import { BubbleMenu } from '@tiptap/react/menus';
import { Bold, Italic, Underline, Link as LinkIcon } from 'react-feather';
import { ToolbarButton } from './TipTapToolbar';
import { promptForLink, TEXT_COLOR_PRESETS } from './tiptapToolbarUtils';

function TipTapBubbleMenu({ editor }) {
  if (!editor || editor.isDestroyed) return null;

  return (
    <BubbleMenu editor={editor} className="sk-tiptap-bubble-menu">
      <ToolbarButton
        title="Bold"
        isActive={editor.isActive('bold')}
        onClick={() => editor.chain().focus().toggleBold().run()}
      >
        <Bold size={14} />
      </ToolbarButton>
      <ToolbarButton
        title="Italic"
        isActive={editor.isActive('italic')}
        onClick={() => editor.chain().focus().toggleItalic().run()}
      >
        <Italic size={14} />
      </ToolbarButton>
      <ToolbarButton
        title="Underline"
        isActive={editor.isActive('underline')}
        onClick={() => editor.chain().focus().toggleUnderline().run()}
      >
        <Underline size={14} />
      </ToolbarButton>
      <ToolbarButton
        title="Link"
        isActive={editor.isActive('link')}
        onClick={() => promptForLink(editor)}
      >
        <LinkIcon size={14} />
      </ToolbarButton>
      {TEXT_COLOR_PRESETS.filter((p) => p.value).slice(0, 5).map((p) => (
        <button
          key={p.value}
          type="button"
          className="sk-tiptap-swatch sk-tiptap-swatch-sm"
          title={p.label}
          style={{ background: p.value }}
          onClick={() => editor.chain().focus().setColor(p.value).run()}
        />
      ))}
      <ToolbarButton
        title="Highlight"
        isActive={editor.isActive('highlight')}
        onClick={() => editor.chain().focus().toggleHighlight({ color: '#fff0b3' }).run()}
      >
        <span className="sk-tiptap-highlight-icon sk-tiptap-highlight-icon-sm">A</span>
      </ToolbarButton>
    </BubbleMenu>
  );
}

export default TipTapBubbleMenu;
